import { render, staticRenderFns } from "./StickerCta.vue?vue&type=template&id=e2cb1d1a&"
import script from "./StickerCta.vue?vue&type=script&lang=js&"
export * from "./StickerCta.vue?vue&type=script&lang=js&"
import style0 from "./StickerCta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports